import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query GetQuote($uuid: ID!) {
    getQuote(uuid: $uuid) {
      options {
        provisioningPeriod
        billingPeriod
        pricePerMonth
        pointsPerYear
        lengthOfContractInMonths
        quoteId
      }
      errorMessage
      currency
    }
  }
`

export const getQuoteKey = getQueryNames(query)[0]

export default query
